import { getMainDomain, isLocalhostSite } from './url'

export const isMobile = (): boolean => {
    if (typeof window === 'undefined') return false
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const goLiveChat = () => {
    // live chat url from nami now, not from hector anymore
    const url = isLocalhostSite()
        ? 'https://www.google.com'
        : `//callcenter.${getMainDomain()}/Faq`

    const iHeight = 670
    const iWidth = 315
    const iTop = window.screen.availHeight - 80 - iHeight
    const iLeft = window.screen.availWidth - 20 - iWidth

    window.open(
        url,
        '_blank',
        `left=${iLeft},top=${iTop},width=${iWidth},height=${iHeight},toolbar=1,resizable=0`,
    )
}
